import { type SelectOption } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { Recipients } from './utils'

export const reviewOptions = () => {
  return [
    {
      value: Recipients.self,
      label: i18n.t('automations.actions.send_notification.review_completed.relation_self'),
    },
  ]
}

export const documentOptions = () => {
  return [
    {
      value: Recipients.self,
      label: i18n.t('automations.actions.send_notification.document_created.relation_self'),
    },
    {
      value: Recipients.manager,
      label: i18n.t('automations.actions.send_notification.document_created.relation_manager'),
    },
    {
      value: Recipients.timeoff_manager,
      label: i18n.t(
        'automations.actions.send_notification.document_created.relation_timeoff_manager'
      ),
    },
    {
      value: Recipients.employeesTeamLead,
      label: i18n.t(
        'automations.actions.send_notification.document_created.relation_employees_team_lead'
      ),
    },
  ]
}

export const leaveOptions = () => {
  return [
    {
      value: Recipients.timeoff_manager,
      label: i18n.t('automations.actions.send_notification.leave_created.relation_timeoff_manager'),
    },
    {
      value: Recipients.manager,
      label: i18n.t('automations.actions.send_notification.recipient.manager'),
    },
    {
      value: Recipients.self,
      label: i18n.t('automations.actions.send_notification.recipient.relation_self'),
    },
  ]
}

export const defaultOptions = () => {
  return [
    {
      value: Recipients.self,
      label: i18n.t('automations.actions.send_notification.recipient.relation_self'),
    },
    {
      value: Recipients.manager,
      label: i18n.t('automations.actions.send_notification.recipient.manager'),
    },
    {
      value: Recipients.timeoff_manager,
      label: i18n.t('automations.actions.send_notification.recipient.time_off_manager'),
    },
    {
      value: Recipients.employeesTeamLead,
      label: i18n.t('automations.actions.send_notification.recipient.employees_team_lead'),
    },
  ]
}

export const applicationOptions = () => {
  return [
    {
      value: Recipients.self,
      label: i18n.t('automations.actions.send_notification.ats_application.candidate'),
    },
  ]
}

export const groupOptions = (): SelectOption[] => {
  return [
    {
      value: Recipients.admins,
      label: i18n.t('automations.actions.send_notification.relation_admins'),
    },
    {
      value: Recipients.basics,
      label: i18n.t('automations.actions.send_notification.relation_basics'),
    },
    {
      value: Recipients.team,
      label: i18n.t('automations.actions.send_notification.notifiable_team'),
    },
    {
      value: Recipients.teamLead,
      label: i18n.t('automations.actions.send_notification.leave_created.relation_team_lead'),
    },
    {
      value: Recipients.managers,
      label: i18n.t('automations.actions.send_notification.notifiable_managers'),
    },
    {
      value: Recipients.location,
      label: i18n.t('automations.actions.send_notification.notifiable_location'),
    },
    {
      value: Recipients.everyone,
      label: i18n.t('automations.actions.send_notification.relation_everyone'),
    },
    {
      value: Recipients.permissionGroup,
      label: i18n.t('automations.actions.send_notification.notifiable_permission_group'),
    },
    {
      value: Recipients.legalEntity,
      label: i18n.t('automations.actions.send_notification.notifiable_legal_entity'),
    },
  ].sort((a, b) => a.label.localeCompare(b.label))
}
